import {type Type} from '@packages/systems/wfdl';

export const migrateGenericTypeStructure = (dataTypeJson: any) => {
  if (
    dataTypeJson &&
    dataTypeJson.type === 'Generic' &&
    typeof dataTypeJson.val === 'undefined'
  ) {
    const newDataType: Type = {
      type: 'Generic',
      val: {
        arg: dataTypeJson.arg,
        body: dataTypeJson.body,
      },
    };

    if (dataTypeJson.system) newDataType.system = dataTypeJson.system;
    if (dataTypeJson.meta) newDataType.meta = dataTypeJson.meta;

    return newDataType;
  }

  return dataTypeJson;
};
